import { object, string, func } from 'prop-types';
import React from 'react';
import {QuizSentenceWithTooltip} from '../QuizSentence/index';
import ReactMarkdown from 'react-markdown';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const CreateQuizPreview = ({editText,options, blankColor,onClickAnswer,t, className})=>{
	let blankIndex = 0;
	const QuizSentenceRenderer = (props) => <QuizSentenceWithTooltip 
		key={props.children}
		content={props.children}
		onClickBlank={onClickAnswer}
		options={options}
		blankColor={blankColor}
		onAssignBlank={()=>{return blankIndex++;}}
	/>;
	const previewWithMarkdown = <ReactMarkdown 
		source={editText}
		renderers={{text:QuizSentenceRenderer}}
	/>;
    	return (
		<div className={className}>
			<h4>{t('create-quiz-modal.Preview')}</h4>
			<style.Preview>
				{previewWithMarkdown}
			</style.Preview>
		</div>
    	);
};
CreateQuizPreview.propTypes = {
	editText:string,
	options:object,
	onClickAnswer:func,
	t : func,
	className : string,
	blankColor : string,
};
export default withNamespaces()(CreateQuizPreview);